import { render, staticRenderFns } from "./DynamicAttributeUpdate.vue?vue&type=template&id=478bcadf&"
import script from "./DynamicAttributeUpdate.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports